/* i18n 实例，node 和 browser 共享 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// import XHR from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { Resources } from './typings';
import { formatLng } from './utils';
import { starlingLog } from './log';

// ssr i18nData -> window._SSR_DATA.data.i18nData
export function exportI18nData(
  context: any, // ServerContext
  requestI18n: any,
  waitList: any[],
) {
  const initialI18nStore: Resources = {};
  (requestI18n?.languages || []).forEach((l: string) => {
    initialI18nStore[l] = requestI18n.services.resourceStore.data[l];
  });
  const initialLanguage = requestI18n?.language;

  context.__i18nData__ = {
    resources: Object.keys(initialI18nStore).length
      ? JSON.parse(JSON.stringify(initialI18nStore))
      : null,
    cdnUrlList: waitList
      .map(item => {
        return item[2].url;
      })
      .filter(Boolean),
    lng: initialLanguage,
  };

  waitList.forEach(([locale, namespace, i18nData]) => {
    requestI18n.addResources(locale, namespace, i18nData.data);
  });
}

export async function initI18nData(
  {
    projectName,
    namespace,
    locale,
    cdn,
    zone,
    fetchOptions,
    debug,
  }: {
    projectName: string;
    namespace: string;
    locale: string;
    cdn: boolean;
    zone?: string;
    fetchOptions: Record<string, any>;
    debug?: boolean;
  } = {} as any,
) {
  const Client = cdn
    ? require('@jupiter/starling-node')
    : require('@ies/starling_node');
  let data = {};
  if (debug) {
    starlingLog(
      'Starling Node Params:',
      'projectName =',
      projectName,
      'namespace =',
      namespace,
      'options =',
      JSON.stringify({
        fetchOptions,
      }),
      'cdn =',
      cdn,
    );
  }
  try {
    const client = new Client(
      projectName,
      namespace,
      cdn ? zone : { fetchOptions },
      cdn ? fetchOptions : undefined,
    );
    data = await client.getPackage(formatLng(locale));
    if (debug) {
      starlingLog('Starling Node Result:', data);
    }
  } catch (e) {
    // do nothing
  }

  return data;
}

export const options = {
  // 优先通过语言检测，如果未检测出，会用该降级语言
  fallbackLng: 'en',
  // load: 'languageOnly', // we only provide en, de -> no region specific locals like en-US, de-DE
  // have a common namespace used around the full app
  ns: ['translation'],
  defaultNS: 'translation',

  saveMissing: true,
  debug: false,

  react: {
    useSuspense: false,
  },
  interpolation: {
    escapeValue: false, // not needed for react!!
    // formatSeparator: ',',
    // format: (value, format, lng) => {
    //   if (format === 'uppercase') return value.toUpperCase();
    //   return value;
    // },
  },
  // wait: process && !process.release,
  detection: {
    caches: ['cookie', 'localStorage'],
    order: [
      'querystring',
      'cookie',
      'localStorage',
      'navigator',
      'htmlTag',
      'path',
      'subdomain',
    ],
    cookieMinutes: 60 * 24 * 365,
    lookupQuerystring: 'lng',
    lookupCookie: 'i18next',
    lookupLocalStorage: 'i18nextLng',
  },
  backend: {
    loadPath: 'locales/{{lng}}.json',
    jsonIndent: 2,
  },
};

// for browser use xhr backend to load translations and browser lng detector
if (process.browser) {
  i18n
    // .use(XHR)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    .use(LanguageDetector);
}

// node 环境的配置
if (!process.browser) {
  const Backend = require('i18next-node-fs-backend');

  i18n.use(Backend).use(require('i18next-express-middleware').LanguageDetector);
}

// initialize if not already initialized
if (!i18n.isInitialized) {
  i18n.init(options);
}

export { i18n };
